<div class="premium-coverage-modal-close" (click)="handleCancel()">
  <mat-icon matDatepickerToggleIcon>close</mat-icon>
</div>
<div class="premium-coverage-modal">
  <div class="title text-center">
    <h2>Find premium layers on your waterway</h2>
  </div>
  <div class="premium-coverage-modal-content">
    <div class="premium-coverage-modal-content-inner">
      <div fxLayout="row" class="premium-coverage-form premium-coverage-modal-content--with-indent">
        <div fxLayout="column" class="column">
          <div class="select-state">
            <mat-form-field>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <input
                    matInput
                    placeholder="Choose a State"
                    aria-label="Choose a State"
                    [matAutocomplete]="autoRegion"
                    [formControl]="regionControl"
                    (change)="onChange()"
                    (keyup)="onKeyupState(inputState)"
                    [(ngModel)]="inputState"
                  />
                  <mat-autocomplete #autoRegion="matAutocomplete" (optionSelected)="onRegionSelected($event.option.value)">
                    <mat-option *ngFor="let region of (filteredRegion | async)" [value]="region.name">
                      {{ region.name }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
                <mat-icon *ngIf="!isCloseState" matDatepickerToggleIcon (click)="cleanState()" class="close">close</mat-icon>
                <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </div>
            </mat-form-field>
          </div>
          <div class="select-premium-waterway">
            <mat-form-field>
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="start center">
                  <input
                    matInput
                    placeholder="Select Waterway"
                    [matAutocomplete]="autoWaterway"
                    [formControl]="waterwayControl"
                    (keyup)="onKeyupWaterway(inputWaterway)"
                    [(ngModel)]="inputWaterway"
                  />
                  <mat-autocomplete #autoWaterway="matAutocomplete" (optionSelected)="onWaterwaySelection($event.option.value)">
                    <mat-option *ngFor="let waterway of (filteredWaterways | async)" [value]="waterway.name">
                      {{ waterway.name }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
                <mat-icon *ngIf="!isCloseWaterway" matDatepickerToggleIcon (click)="cleanWaterway()" class="close">close</mat-icon>
                <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
              </div>
            </mat-form-field>
          </div>
          <button class="button button-premium" (click)="navigatePremium()">Go Premium</button>
        </div>
        <div class="map-content">
          <div class="map-content-inner">
            <app-mapbox [style]="style" [center]="[-74.5, 40]" [zoom]="DEFAULT_MAP_ZOOM" (load)="mapLoad($event)"></app-mapbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
